import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class OptConfigProvider extends Component {
  constructor (props) {
    super(props);
    this.el = props.el;
  }

  getChildContext () {
    const el = this.props.el || this.el;

    let csrfParam;
    let csrfToken;

    try {
      csrfParam = document.querySelector('meta[name=csrf-param]').getAttribute('content');
      csrfToken = document.querySelector('meta[name=csrf-token]').getAttribute('content');
    } catch (err) {
      console.error(err);
    }

    return { csrfParam, csrfToken, el };
  }

  render () {
    return this.props.children;
  }
}
OptConfigProvider.propTypes = {
  children: PropTypes.node.isRequired,
  /* eslint-disable react/forbid-prop-types */
  el: PropTypes.object.isRequired,
  /* eslint-enable react/forbid-prop-types */
};

OptConfigProvider.childContextTypes = {
  /* eslint-disable react/forbid-prop-types */
  el: PropTypes.object.isRequired,
  /* eslint-enable react/forbid-prop-types */
  csrfParam: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
};

export default function withOptConfig (WrappedComponent, el) {
  class OptConfigProviderHoc extends OptConfigProvider {
    constructor (props) {
      super(props);
      this.el = el;
    }

    render () {
      return <WrappedComponent {...this.props} />;
    }
  }

  OptConfigProviderHoc.propTypes = {};

  return OptConfigProviderHoc;
}
